/** @file English catalog part of area E1 (W3-03); replaced whole by that area. */

/** The `tools.<id>.title` keys of the seven E1 tools (spread into `tools`). S0 composes it into `en`. */
export const toolsEn = {
  select: { title: 'Select' },
  translate: { title: 'Translate' },
  rotate: { title: 'Rotate' },
  scale: { title: 'Scale' },
  createBone: { title: 'Create bone' },
  ik: { title: 'IK' },
  grabItem: { title: 'Grab item' },
} as const;
